
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/patients/test-call.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import Header from '@components/Layouts/Header/Header';

import PatientTestCallSession from '@components/Patients/TestCallSession/PatientTestCallSession';

const PatientTestCall = () => {
  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="Test Call" />
      <section className="section-layout patient-test-call patient">
        <main className="container" id="page-content">
          <PatientTestCallSession />
        </main>
      </section>
    </div>
  );
};


export const Route = createFileRoute('/patients/test-call')({ component: PatientTestCall });
